import { useEffect, useRef } from "react";

// A duplicate history entry on top catches the phone's back gesture; capturing runs
// before Inertia's listener, which would otherwise re-render the page from it.
let armed = false;
let handleBack: (() => void) | null = null;

if (typeof window !== "undefined") {
  window.addEventListener(
    "popstate",
    (e) => {
      if (!armed) return;
      e.stopImmediatePropagation();
      armed = false;
      handleBack?.();
    },
    true,
  );
}

function arm() {
  window.history.pushState(window.history.state, "", window.location.href);
  armed = true;
}

export function useBackDismiss(dismiss: () => void, staysOpenAfterDismiss: () => boolean) {
  const callbacksRef = useRef({ dismiss, staysOpenAfterDismiss });
  callbacksRef.current = { dismiss, staysOpenAfterDismiss };

  useEffect(() => {
    const openedAt = window.location.href;
    handleBack = () => {
      const { dismiss, staysOpenAfterDismiss } = callbacksRef.current;
      const staysOpen = staysOpenAfterDismiss();
      dismiss();
      if (staysOpen) arm();
    };
    arm();
    return () => {
      handleBack = null;
      if (!armed) return;
      if (window.location.href === openedAt) window.history.back();
      else armed = false;
    };
  }, []);
}
